import Cookies from 'js-cookie'

interface IRefs {
  clickId?: string
  offer?: string
  partnerId?: string
  gaClickId?: string
  referral?: string
  registrationSourceId?: string
  subid3?: string
}

export const clearReferralCookies = () => {
  Cookies.remove(`offer`)
  Cookies.remove(`click_id`)
  Cookies.remove(`partner_id`)
  Cookies.remove(`_ga`)
}

const getReferralCookies = (): IRefs => {
  const referral = localStorage.getItem(`_ref`)
  const offer = Cookies.get(`offer`)
  const clickId = Cookies.get(`click_id`)
  const partnerId = Cookies.get(`partner_id`)
  const gaClickId = Cookies.get(`_ga`)
  const registrationSourceId = Cookies.get(`registrationSourceId`)
  const refs: IRefs = {}
  if (clickId) refs.clickId = clickId
  if (offer) refs.offer = offer
  if (gaClickId) refs.gaClickId = gaClickId
  if (partnerId) refs.partnerId = partnerId
  if (referral) refs.referral = referral
  if (registrationSourceId) refs.registrationSourceId = registrationSourceId
  return refs
}

export default getReferralCookies
